import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { DevopsIdentity, DevopsPlatformIdentity, DevopsProxy } from '../../services/devops.service';
import type { DevopsState } from './devops.reducer';

export type DevopsOverviewSnapshot = Partial<
  Omit<DevopsState, 'loading' | 'busy' | 'error' | 'lastLoadedAt'>
>;

type DevopsSelectionPatch = Partial<
  Pick<DevopsState, 'selectedSpaceId' | 'selectedCapsuleId' | 'selectedBuildId' | 'buildLog' | 'builds'>
>;

export const DevopsActions = createActionGroup({
  source: 'Devops',
  events: {
    'Load Started': emptyProps(),
    'Overview Loaded': props<{ snapshot: DevopsOverviewSnapshot }>(),
    'Load Failed': props<{ error: string }>(),
    'Busy Started': emptyProps(),
    'Busy Ended': emptyProps(),
    Failed: props<{ error: string }>(),
    'Identity Set': props<{ identity: DevopsIdentity | null }>(),
    'Platform Set': props<{ platform: DevopsPlatformIdentity | null }>(),
    'Proxy Set': props<{ proxy: DevopsProxy | null }>(),
    'Selection Patched': props<{ selection: DevopsSelectionPatch }>(),
    'Logged Out': emptyProps(),
    Reset: emptyProps(),
  },
});
